var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash"},[_c('div',{staticClass:"spin-wrap"},[_c('div',{staticClass:"spinner"})]),_c('img',{attrs:{"src":require("@/assets/froot_logo.jpg"),"alt":"Loading Froot Wheel","width":"100%"}})])
}]

export { render, staticRenderFns }